
import { addSocketMessageListener } from "@/api/socketAPI";
import SocketMessageType from "@/constants/SocketMessageType";
import { store } from "@/store/store";
import { teamAPI } from "@/api";

const processTeamUpdate = async ( { body, } ) => {
	const { teamId, } = body;
	if ( !teamId ) {
		console.warn( "team API orchestrator: a team was expected but was not detected" );
		return;
	}
	try {
		const team = await teamAPI.fetchTeam( { teamId, } );
		store.commit( "teamManagement/teamUpdated", team );
		store.commit( "updatedTeam", team );
	} catch ( e ) {
		console.error( "error updating team stores", body, e );
	}
};

export const initWebSocketListeners = () => {
	[
		SocketMessageType.TEAM_UPDATED,
	].forEach( messageType => addSocketMessageListener( messageType, processTeamUpdate ) );
};



// WEBPACK FOOTER //
// ./src/store/modules/teamManagement/teamApiOrchestrator.js